const KEY = 'tc_job_teaser_token';
const TTL_MS = 30 * 24 * 60 * 60 * 1000;

interface StoredTeaserToken {
  token: string;
  expiresAt: number;
}

export function saveTeaserToken(token: string): void {
  if (typeof window === 'undefined') return;
  const trimmed = token.trim();
  if (!trimmed) return;
  try {
    const payload: StoredTeaserToken = { token: trimmed, expiresAt: Date.now() + TTL_MS };
    localStorage.setItem(KEY, JSON.stringify(payload));
  } catch (err) {
    console.warn('[teaserStorage] Failed to persist token:', err);
  }
}

export function getTeaserToken(): string | undefined {
  if (typeof window === 'undefined') return undefined;
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return undefined;

    const parsed = JSON.parse(raw) as StoredTeaserToken;
    if (!parsed?.token || typeof parsed.expiresAt !== 'number') return undefined;
    if (Date.now() > parsed.expiresAt) {
      localStorage.removeItem(KEY);
      return undefined;
    }
    return parsed.token;
  } catch (err) {
    console.warn('[teaserStorage] Failed to read token:', err);
    return undefined;
  }
}

export function clearTeaserToken(): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.removeItem(KEY);
  } catch (err) {
    console.warn('[teaserStorage] Failed to clear token:', err);
  }
}
